import LazyIllustration from './LazyIllustration';
export * from './LazyIllustration';
export default LazyIllustration;
